import Vue from 'vue'
import {USER_INFO, ACCESS_TOKEN, WHITE_PATHS, WHITE_PATHS_BY_SHARE_INIT, WHITE_PATHS_BY_SHARE_INIT_168} from '../store/mutation-types'
import { traceApi, uploadSession, userSearchLog, shareLogApi } from '@/api/trace.js'
import {pollingPath, entranceFromPath, entranceToPath, getUrlParms} from './util'

/**
 *
 * @returns 获取随机uuid 来当session_id
 */
function getUuid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function boolRouterHasUndefined (to, from) {
  if (to.fullPath.indexOf('/courserDetails') > -1 || to.fullPath.indexOf('/scormCourseDetail') > -1) {
    return !(to.query.courseId === 'undefined')
  }
  if (from.fullPath.indexOf('/courserDetails') > -1 || from.fullPath.indexOf('/scormCourseDetail') > -1) {
    return !(from.query.courseId === 'undefined')
  }
  if (to.fullPath.indexOf('/zoneDetails') > -1) {
    return !(to.query.areaId === 'undefined')
  }
  if (from.fullPath.indexOf('/zoneDetails') > -1) {
    return !(from.query.areaId === 'undefined')
  }
  if (to.fullPath.indexOf('/dccDetail') > -1) {
    return !(to.query.postId === 'undefined' || to.query.areaId === 'undefined')
  }
  if (from.fullPath.indexOf('/dccDetail') > -1) {
    return !(from.query.postId === 'undefined' || from.query.areaId === 'undefined')
  }
  if (to.fullPath.indexOf('/answerWork') > -1) {
    return !(to.query.postId === 'undefined' || to.query.areaId === 'undefined')
  }
  if (from.fullPath.indexOf('/answerWork') > -1) {
    return !(from.query.postId === 'undefined' || from.query.areaId === 'undefined')
  }
  if (to.fullPath.indexOf('/trainingDetail') > -1) {
    return !(to.query.campId === 'undefined')
  }
  if (from.fullPath.indexOf('/trainingDetail') > -1) {
    return !(from.query.campId === 'undefined')
  }
  if (to.fullPath.indexOf('/trainCourse') > -1) {
    return !(to.query.campId === 'undefined')
  }
  if (from.fullPath.indexOf('/trainCourse') > -1) {
    return !(from.query.campId === 'undefined')
  }
  if (to.fullPath.indexOf('/questionDetails') > -1) {
    return !(to.query.questionId === 'undefined')
  }
  if (from.fullPath.indexOf('/questionDetails') > -1) {
    return !(from.query.questionId === 'undefined')
  }
  return true
}

const sessionId = getUuid()

/**
 * 转换时间格式
 * @param date  传入得日期
 * @param fmt 格式
 * @returns
 */
export function getDate (date) {
  // date是传过来的时间戳，注意需为13位，10位需*1000
  // 也可以不传,获取的就是当前时间
  const time = new Date(Number(date))
  const year = time.getFullYear() // 年
  const month = ('0' + (time.getMonth() + 1)).slice(-2) // 月
  const day = ('0' + time.getDate()).slice(-2) // 日
  const hour = ('0' + time.getHours()).slice(-2) // 时间
  const minute = ('0' + time.getMinutes()).slice(-2) // 时间
  const second = ('0' + time.getSeconds()).slice(-2) // 停留时长 // 时间
  const mydate =
    year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
  return mydate
}

/**
 *
 * @returns 返回设备的系统，目前值判断安卓iOS
 */
export function getOS () {
  const ua = navigator.userAgent.toLowerCase()
  let OS = ''
  if (ua.indexOf('android') > 0) {
    OS = 'android'
  } else if (ua.indexOf('iphone') > 0) {
    OS = 'IOS'
  } else if (ua.indexOf('windows') > 0) {
    OS = 'windows'
  } else if (ua.indexOf('mac') > 0) {
    OS = 'mac'
  }
  return OS
}

/**
 *
 * @returns 返回设备的系统版本，目前值判断安卓iOS
 */
export function getOSversion () {
  let osVersion = ''
  if (getOS() === 'android') {
    osVersion = getAndroidVerion()
  } else if (getOS() === 'IOS') {
    osVersion = getIOSersion()
  } else if (getOS() === 'windows') {
    osVersion = getWindowsersion()
  } else if (getOS() === 'mac') {
    osVersion = getMacersion()
  }
  return osVersion
}

// 获取Android版本号
function getAndroidVerion () {
  const ua = navigator.userAgent.toLowerCase()
  let version = ''
  if (ua.indexOf('android') > 0) {
    const reg = /android [\d._]+/gi
    const vInfo = ua.match(reg)
    version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.') // 得到版本号4.2.2
    // version = parseInt(version.split('.')[0]);// 得到版本号第一位
  }
  return version
}

// 获取iOS版本号
function getIOSersion () {
  const ua = navigator.userAgent.toLowerCase()
  let version = ''
  if (ua.indexOf('like mac os x') > 0) {
    const reg = /os [\d._]+/gi
    const vInfo = ua.match(reg)
    version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.') // 得到版本号9.3.2或者9.0
    // version = parseInt(version.split('.')[0]); // 得到版本号第一位
  }
  return version
}

// 获取Windows版本号
function getWindowsersion () {
  const ua = navigator.userAgent.toLowerCase()
  let version = ''
  const reg = /nt [\d._]+/gi
  const vInfo = ua.match(reg)
  version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.') // 得到版本号9.3.2或者9.0
  // version = parseInt(version.split('.')[0]); // 得到版本号第一位
  return version
}

// 获取Mac版本号
function getMacersion () {
  const ua = navigator.userAgent.toLowerCase()
  let version = ''
  const reg = /x [\d._]+/gi
  const vInfo = ua.match(reg)
  version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.') // 得到版本号9.3.2或者9.0
  // version = parseInt(version.split('.')[0]); // 得到版本号第一位
  return version
}
let isLoadSession = false
export function getSession (object) {
  if (object.to && WHITE_PATHS.indexOf(object.to.path) !== -1 && object.to.path !== '/loginPage' && object.to.path.indexOf('AIFV') < 0) return
  if ((window && localStorage.getItem('sessionId')) || isLoadSession) {
    setTimeout(() => {
      trackPageView(object.to, object.from, object.lasterStartTime, object.typeTxt)
    })
    return
  }
  isLoadSession = true
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  const params = {
    userId: userInfo.id,
    userType: userInfo.userType,
    clientId: userInfo.clientId,
    os: getOS(),
    osVersion: getOSversion(),
    multiCode: userInfo.multiCode,
    portType: 1
  }
  uploadSession(params).then(res => {
    if (window) {
      localStorage.setItem('sessionId', res.data)
      if (object.type === 'PV') {
        trackPageView(object.to, object.from, object.lasterStartTime, object.typeTxt)
      } else if (object.type === 'UV') {
        handleTraceVideo(object.videoData)
      }
    }
  })
}

export function handleGetSession (to) {
  if (to && WHITE_PATHS.indexOf(to.path) !== -1 && to.path !== '/loginPage') return
  isLoadSession = true
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  const params = {
    userId: userInfo.id,
    userType: userInfo.userType,
    clientId: userInfo.clientId,
    os: getOS(),
    osVersion: getOSversion(),
    multiCode: userInfo.multiCode,
    portType: 1
  }
  uploadSession(params).then(res => {
    localStorage.setItem('sessionId', res.data)
  })
}

let pageViewAsync = {}
let fromAsync = {}
let toAsync = {}
let startTime = new Date()
let endTime = new Date()
let duration = 0
let monitorDuration = 0
export let timeoutPolling = null
// 监听当前是否息屏
window.addEventListener('mousemove', () => {
  duration = staticTime()
})
window.addEventListener('touchmove', function () {
  console.log(duration, '=-=-')
  duration = staticTime()
})
window.addEventListener('touchend', function () {
  duration = staticTime()
})
window.addEventListener('popstate', function () {
  duration = staticTime()
}, false)
function monitor () {
  if (!window) return
  return new Promise((resolve, reject) => {
    window.addEventListener('touchend', function () {
      duration = staticTime()
    })
    if (duration === 0) {
      duration = staticTime()
    }
    resolve(duration)
  })
}

export function staticTime () {
  if ((new Date().getTime() - new Date(endTime).getTime()) / 1000 > 29) {
    if ((toAsync.path && (pollingPath.includes(toAsync.path) || toAsync.path.indexOf('AIFV') > 0)) && (new Date().getTime() - new Date(endTime).getTime()) / 1000 > 30) {
      endTime = new Date()
      asyncJourney(pageViewAsync, fromAsync, toAsync)
    }
    startTime = new Date()
    endTime = new Date()
    // 息屏时间累加
    duration = duration + 30
    monitorDuration = duration
  } else {
    endTime = new Date()
    let startTimeCount = startTime// localStorage.getItem('startTime') && !OFFSCREENFLAG ? Number(localStorage.getItem('startTime')) : startTime
    duration = monitorDuration + Math.ceil((new Date(endTime).getTime() - new Date(startTimeCount).getTime()) / 1000)
  }
  return duration
}

export async function trackPageView (to, from, lasterStartTime, type) {
  // 判断一进来不用埋点
  if (window && !localStorage.getItem('sessionId')) {
    getSession({ to, from, lasterStartTime, typeTxt: type, type: 'PV' })
    return
  }
  if (!boolRouterHasUndefined(to, from)) return
  // 167/168 分享进入由 permission afterEach 上报；leave PV 的 pageId 是目标页，会双发 type/2
  const toEntrance = to && to.query && to.query.entrance
  if (WHITE_PATHS_BY_SHARE_INIT.indexOf(to.path) !== -1 && toEntrance == 167) return
  if (WHITE_PATHS_BY_SHARE_INIT_168.indexOf(to.path) !== -1 && toEntrance == 168) return
  // if ((to.path && to.path.indexOf('undefined') > -1) || (from.path && from.path.indexOf('undefined') > -1)) return
  if (!to || !from || (window && !localStorage.getItem('sessionId'))) return
  let title = window.sessionStorage.getItem('traceTitle') ? window.sessionStorage.getItem('traceTitle') : from.name
  let dur = await monitor()
  let sourceUserId = null
  if (entranceFromPath.includes(from.path) || entranceToPath.includes(to.path) || pollingPath.includes(to.path)) {
    if (entranceFromPath.includes(from.path)) {
      sourceUserId = from.query.userId
    } else if (entranceToPath.includes(to.path) || pollingPath.includes(to.path)) {
      sourceUserId = to.query.userId
    }
  }
  const durTime = dur > 0 ? dur : Math.ceil((new Date().getTime() - new Date(startTime).getTime()) / 1000) > 0 ? Math.ceil((new Date().getTime() - new Date(startTime).getTime()) / 1000) : 1
  let moduleName = from.meta.moduleName
  moduleName = window.sessionStorage.getItem('moduleName') ? window.sessionStorage.getItem('moduleName') : moduleName
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  const token = Vue.ls.get(ACCESS_TOKEN) ? Vue.ls.get(ACCESS_TOKEN) : {}
  let serviceId, entrance, campId, channel
  if (entranceFromPath.includes(from.path) || entranceToPath.includes(to.path) || pollingPath.includes(to.path)) {
    serviceId = sessionStorage.getItem('serviceId') || ''
    entrance = sessionStorage.getItem('entrance') || ''
    if (entranceFromPath.includes(from.path)) {
      entrance = from.query.entrance || entrance
      campId = from.query.businessId || ''
      channel = from.query.channel || ''
    } else if (entranceToPath.includes(to.path) || pollingPath.includes(to.path)) {
      entrance = to.query.entrance || entrance
      campId = to.query.businessId || ''
      channel = to.query.channel || ''
    }
  } else {
    entrance = ''
    channel = ''
    serviceId = ''
    campId = ''
  }
  const pageView = {
    sessionId: window && localStorage.getItem('sessionId'), // 会话ID
    moduleName,
    pageId: to.fullPath, // 当前页面Id，传当前路劲过去
    pageName: title, // 当前页面名称
    referrerId: from.fullPath, // 上一个页面的Id，传上个页面的path过去
    // referrerName: from.name, // 上一个页面的名称
    duration: durTime, // 页面停留时长，向上取整
    incidentType: '2',
    url: to.fullPath,
    urlPath: to.path,
    triggerTime: getDate(new Date(lasterStartTime).getTime()), // getDate(new Date().getTime() - durTime * 1000), // 触发时间
    userId: userInfo.id, // 用户id
    sourceUserId,
    serviceId,
    entrance,
    campId,
    channel,
  }
  // 如果离开课程页面的时候有shareId，就带上
  if (from.path === '/courserDetails' && from.query.shareId) {
    pageView.shareId = from.query.shareId
  }
  sessionStorage.removeItem('serviceId')
  sessionStorage.setItem('serviceIdCopy', serviceId)
  if (!pageView.userId) return
  startTime = new Date()
  duration = 0
  monitorDuration = 0
  if (pollingPath.includes(to.path) || to.path.indexOf('AIFV') > 0) {
    if (type === 'isLeave') {
      syncJourney(pageView, from, token)
      return
    }
    asyncJourney(pageView, from, to)
  } else {
    syncJourney(pageView, from, token)
  }
}

function syncJourney (pageView, from, token) {
  if (pollingPath.includes(from.path) || from.path.indexOf('AIFV') > 0) return
  // if (from.path === '/pdfView' || from.path.indexOf('AIFV') > 0 || from.path === '/') return
  fetch(`${process.env.baseURL}/api/logs/type/${pageView.incidentType}`, {
    method: 'POST',
    body: JSON.stringify(pageView),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    keepalive: true
  }).then(() => {
    if (from.path !== '/loginPage') {
      window && window.sessionStorage.removeItem('moduleName')
    }
    sessionStorage.removeItem('journeyPageViewId')
  })
}

function asyncJourney (pageView, from, to) {
  pageViewAsync = pageView
  fromAsync = from
  toAsync = to
  if (window.location.href.indexOf(to.path) < 0) return
  if (JSON.parse(sessionStorage.getItem('pollingOver'))) {
    sessionStorage.removeItem('journeyPageViewId')
    clearTimeout(timeoutPolling)
    return
  }
  pageView.referrerId = to.fullPath
  const title = window.sessionStorage.getItem('traceTitle') ? window.sessionStorage.getItem('traceTitle') : to.name
  pageView.pageName = title
  pageView.moduleName = pageView.moduleName || to.meta.moduleName
  if (sessionStorage.getItem('journeyPageViewId')) {
    pageView.id = sessionStorage.getItem('journeyPageViewId')
    pageView.duration = 6
  } else {
    pageView.duration = 1
  }
  if ((new Date().getTime() - new Date(endTime).getTime()) / 1000 < 30) {
    if (!(entranceFromPath.includes(from.path) || entranceToPath.includes(to.path))) {
      pageView.entrance = null
      pageView.channel = null
      pageView.campId = null
      pageView.serviceId = null
    }
    if (pollingPath.includes(to.path)) {
      pageView.serviceId = sessionStorage.getItem('serviceId') || sessionStorage.getItem('serviceIdCopy') || ''
      pageView.entrance = to.query.entrance || (sessionStorage.getItem('entrance') || '')
      pageView.channel = to.query.channel || to.query.entrance || (sessionStorage.getItem('entrance') || '')
      pageView.campId = to.query.businessId || ''
    }
    // 自定义分享：路由有 shareId 才传
    const shareId = getUrlParms('shareId')
    if (shareId) {
      pageView.shareId = shareId
    }
    traceApi(pageView).then((res) => {
      sessionStorage.setItem('journeyPageViewId', res.data)
      timeoutPolling = setTimeout(() => {
        asyncJourney(pageView, from, to)
      }, 6000)
    })
  }
}

// 微信点击叉叉监听，--- 下饭操作压根监听不到
// function visibilitychangeHandler () {
//   const pathToFrom = JSON.parse(sessionStorage.getItem('pathToFrom'))
//   if ((pathToFrom.to.path === '/courserDetails' && pathToFrom.from.path === '/courserDetails') || pathToFrom.to.path === '/pdfView' || pathToFrom.from.path === 'AIFV') return
// }
// window.addEventListener('pageshow', () => { })
// window.addEventListener('pagehide', () => { visibilitychangeHandler() })

export function handleTraceVideo (videoData) {
  if (window && !localStorage.getItem('sessionId')) {
    getSession({ videoData, type: 'UV' })
    return
  }
  let entrance = getUrlParms('entrance') || sessionStorage.getItem('entrance') || ''
  let campId = getUrlParms('businessId') || getUrlParms('questionId') || sessionStorage.getItem('questionId') || ''
  let channel = (entrance === '1' || entrance === '2' || entrance === '3') ? entrance : getUrlParms('channel') || ''
  if (sessionStorage.getItem('video-track-cache')) {
    const {
      entrance: entrance1,
      campId: campId1,
      channel: channel1,
    } = JSON.parse(sessionStorage.getItem('video-track-cache'))
    entrance = entrance1
    campId = campId1
    channel = channel1
  }
  let sectionId = ''
  if (videoData.fileId) {
    sectionId = videoData.sectionId ? videoData.sectionId : videoData.id ? videoData.id : videoData.fileId
  } else if (videoData.videoMaterial) {
    sectionId = videoData.sectionId ? videoData.sectionId : videoData.id ? videoData.id : videoData.videoMaterial.fileId
  } else if (videoData.sectionId) {
    sectionId = videoData.sectionId
  }
  if (!sectionId) return
  // 判断一进来不用埋点
  if (Object.keys(videoData).length <= 0 || (window && !localStorage.getItem('sessionId'))) return
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  const pageView = {
    sessionId: window && localStorage.getItem('sessionId'), // 会话ID
    courseId: videoData.courseId ? videoData.courseId : videoData.baseId,
    sectionId,
    duration: videoData.duration === 0 ? 1 : videoData.duration, // 观看视频时长
    incidentType: '3',
    pageName: videoData.title,
    triggerTime: getDate(new Date().getTime() - videoData.duration * 1000), // 触发时间
    journeyId: videoData.journeyId ? videoData.journeyId : '',
    userId: userInfo.id, // 用户id
    id: sessionStorage.getItem('videoTraceId') ? sessionStorage.getItem('videoTraceId') : '',
    entrance,
    campId,
    channel
  }
  if (videoData.videoMaterial) {
    pageView.videoDuration = videoData.videoMaterial ? videoData.videoMaterial.duration : ''
    pageView.learningStatus = sessionStorage.getItem('curPlayVideoStatus')
  }
  if (sessionStorage.getItem('videoSectionId') && sessionStorage.getItem('videoSectionId') !== pageView.sectionId) {
    sessionStorage.removeItem('videoTraceId')
    sessionStorage.removeItem('videoSectionId')
    pageView.id = ''
  }
  // 自定义分享：路由有 shareId 才传
  const shareId = getUrlParms('shareId')
  if (shareId) {
    pageView.shareId = shareId
  }
  traceApi(pageView).then((res) => {
    if (res.data) {
      sessionStorage.setItem('videoTraceId', res.data)
      sessionStorage.setItem('videoSectionId', pageView.sectionId)
    }
  })
}

export function handleTraceVideoAsync (videoData) {
  if (window && !localStorage.getItem('sessionId')) {
    getSession({ videoData, type: 'UV' })
    return
  }
  // 判断一进来不用埋点
  if (Object.keys(videoData).length <= 0 || (window && !localStorage.getItem('sessionId'))) return
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  let sectionId = ''
  if (videoData.fileId) {
    sectionId = videoData.sectionId ? videoData.sectionId : videoData.id ? videoData.id : videoData.fileId
  } else if (videoData.videoMaterial) {
    sectionId = videoData.sectionId ? videoData.sectionId : videoData.id ? videoData.id : videoData.videoMaterial.fileId
  }
  const entrance = sessionStorage.getItem('entrance') || (getUrlParms('entrance') || '')
  const campId = getUrlParms('businessId') || getUrlParms('questionId') || sessionStorage.getItem('questionId') || ''
  const channel = (entrance === '1' || entrance === '2' || entrance === '3') ? entrance : getUrlParms('channel') || ''
  if (!sectionId) return
  const pageView = {
    sessionId: window && localStorage.getItem('sessionId'), // 会话ID
    courseId: videoData.courseId ? videoData.courseId : videoData.baseId,
    sectionId,
    duration: videoData.duration === 0 ? 1 : videoData.duration, // 观看视频时长
    incidentType: '3',
    pageName: videoData.title,
    triggerTime: getDate(new Date().getTime() - videoData.duration * 1000), // 触发时间
    journeyId: videoData.journeyId ? videoData.journeyId : '',
    userId: userInfo.id, // 用户id
    entrance,
    campId,
    channel
  }
  if (videoData.videoMaterial) {
    pageView.videoDuration = videoData.videoMaterial ? videoData.videoMaterial.duration : ''
    pageView.learningStatus = sessionStorage.getItem('curPlayVideoStatus')
  }
  // 自定义分享：路由有 shareId 才传
  const shareId = getUrlParms('shareId')
  if (shareId) {
    pageView.shareId = shareId
  }
  fetch(`${process.env.baseURL}/api/logs/type/${pageView.incidentType}`, {
    method: 'POST',
    body: JSON.stringify(pageView),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${videoData.token}`
    },
    keepalive: true
  })
}

// 搜索埋点
export function handleTraceSearchLog(searchParams) {
  // 返回一个新的Promise
  return new Promise((resolve, reject) => {
    if (window && !localStorage.getItem('sessionId')) {
      // 调用getSession并等待其完成
      getSession({ searchParams, type: 'SEARCH' }).then(() => {
        resolve() // 完成当前Promise
      }).catch(error => {
        reject(error) // 捕获错误并拒绝当前Promise
      })
      return
    }
    const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
    const pageView = {
      userId: userInfo.id,
      searchContent: searchParams.searchContent,
      createTime: getDate(new Date()),
      sessionId: window && localStorage.getItem('sessionId'), // 会话ID
      type: searchParams.type,
      client: 'mob',
      entrance: searchParams.entrance,
      clientInfo: navigator.userAgent,
    }
    userSearchLog(pageView).then((res) => {
      resolve(res) // 成功时解决Promise
    }).catch(error => {
      reject(error) // 错误时拒绝Promise
    })
  })
}

// 功能按钮埋点
export function handleTraceFunction (functionParams) {
  // if (window && !localStorage.getItem('sessionId')) {
  //   getSession({ functionParams, type: 'SEARCH' })
  //   return
  // }
  // 判断一进来不用埋点
  if ((window && !localStorage.getItem('sessionId'))) return
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  const token = Vue.ls.get(ACCESS_TOKEN) ? Vue.ls.get(ACCESS_TOKEN) : {}
  const pageView = {
    userId: userInfo.id,
    functionName: functionParams.functionName,
    createTime: getDate(new Date(functionParams.createTime)),
    sessionId: window && localStorage.getItem('sessionId'), // 会话ID
    functionUrl: functionParams.functionUrl
  }
  if (functionParams.note) {
    pageView.note = functionParams.note
  }
  if (functionParams.serviceId != null && functionParams.serviceId !== '') {
    pageView.serviceId = functionParams.serviceId
  }
  if (functionParams.campId != null && functionParams.campId !== '') {
    pageView.campId = functionParams.campId
  }
  if (functionParams.entrance != null && functionParams.entrance !== '') {
    pageView.entrance = functionParams.entrance
  }
  // 自定义分享：路由有 shareId 才传
  const shareId = getUrlParms('shareId')
  if (shareId) {
    pageView.shareId = shareId
  }
  fetch(`${process.env.baseURL}/api/user-function`, {
    method: 'POST',
    body: JSON.stringify(pageView),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    keepalive: true
  }).then(() => {
    localStorage.removeItem('functionUrl')
    sessionStorage.removeItem('traceObj')
  })
}

let shareLogTimer = null

// 结束轮询
export function stopLiveShareLog () {
  if (shareLogTimer) {
    clearTimeout(shareLogTimer)
    shareLogTimer = null
  }
  sessionStorage.removeItem('liveShareLogId')
}

// 埋点轮询新接口
function asyncLiveShareLog (sharePageView) {
  if (sessionStorage.getItem('liveShareLogId')) {
    sharePageView.id = sessionStorage.getItem('liveShareLogId')
    sharePageView.duration = 3
  } else {
    sharePageView.duration = 1
  }
  shareLogApi(sharePageView).then((res) => {
    sessionStorage.setItem('liveShareLogId', res.data)
    shareLogTimer = setTimeout(() => {
      asyncLiveShareLog(sharePageView)
    }, 3000)
  })
}

// 开始轮询方法
export function startLiveShareLog (to, lasterStartTime, serviceId) {
  const sessionId = window.localStorage.getItem('sessionId')
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  if (!sessionId || !userInfo.id) return
  let sharePageView = {
    sessionId,
    pageId: to.fullPath,
    pageName: to.name,
    moduleName: (to.meta && to.meta.moduleName) || to.name,
    duration: 1,
    triggerTime: getDate(new Date(lasterStartTime).getTime()),
    serviceId,
    shareLink: window.location.href,
    entrance: to.query.entrance || '',
    channel: to.query.channel || '',
    userId: userInfo.id,
    shareUserId: to.query.shareUserId,
    shareTime: getDate(to.query.shareTime)
  }
  asyncLiveShareLog(sharePageView)
}

export default {
  getUuid,
  getOS,
  getOSversion,
  getDate,
  sessionId,
  handleTraceVideoAsync,
  handleTraceSearchLog,
  handleTraceFunction
}



// WEBPACK FOOTER //
// ./src/utils/trace.js